export default [
  "pending",
  "pending_system_approval",
  "pending_owner_approval",
  "pending_admin_approval",
  "pending_payment_system_approval",
  "pending_insurance_system_approval"
]